import { render } from "./professional-goals.vue?vue&type=template&id=ef78f5e0"
import script from "./professional-goals.vue?vue&type=script&lang=js"
export * from "./professional-goals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__